import PropTypes from 'prop-types'
import { Children, Fragment } from 'react'

const Join = ({ children, divider }) =>
  Children.toArray(children).map((child, i) => (
    <Fragment key={i}>
      {i > 0 && divider}
      {child}
    </Fragment>
  ))

Join.propTypes = {
  children: PropTypes.node,
  divider: PropTypes.node,
}

export default Join
